import { render, staticRenderFns } from "./AppExpansionPanels.vue?vue&type=template&id=bc6f366e&"
import script from "./AppExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./AppExpansionPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports